const STEPS = [
  { n: 1, text: "A thirty-minute call with an engineer. Not a sales team." },
  { n: 2, text: "We look at how you work now, and where the system is costing you time or money." },
  { n: 3, text: "We map the quick wins separately from the bigger build, so you can see which is which." },
  { n: 4, text: "You get a one-page brief: scope, risks, a real cost band and a timeline." },
  { n: 5, text: "The brief is yours either way. Take it to another vendor if you want to. No pressure, no follow-up campaign." },
];

/**
 * Timeline-style "What Happens Next" — five cards in a row on desktop,
 * connected by a thin horizontal line running behind them at card-top.
 * Tablet: two rows (3 + 2). Mobile: stacked with a vertical rail down the
 * left edge of the number instead of the horizontal line.
 */
export function WhatHappensNext() {
  return (
    <section data-testid="what-happens-next-section" className="bg-white">
      <div className="mx-auto max-w-7xl px-4 pb-24 lg:px-6 lg:pb-32">
        <h2
          data-testid="what-happens-next-heading"
          className="text-center font-heading text-3xl font-semibold tracking-tight text-wafa-deep sm:text-4xl lg:text-5xl"
        >
          What Happens Next
        </h2>

        <div className="relative mt-14">
          {/* Desktop horizontal timeline rail — sits behind the cards, at
              the card-top row. Hidden on mobile (see vertical rail on each
              card instead). On tablet the grid wraps to two rows and the
              rail still spans the row width, breaking naturally. */}
          <div
            aria-hidden="true"
            className="pointer-events-none absolute start-6 end-6 top-6 hidden h-px bg-wafa-deep/15 sm:block"
          />

          <ol className="relative grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-5">
            {STEPS.map((s) => (
              <li
                key={s.n}
                data-testid={`what-happens-step-${s.n}`}
                className="relative"
              >
                {/* Mobile-only vertical rail down the left edge of the number */}
                <span
                  aria-hidden="true"
                  className="absolute start-6 top-8 bottom-2 w-px bg-wafa-deep/15 sm:hidden"
                />
                <div className="relative rounded-2xl bg-wafa-cream/70 p-6 lg:p-7">
                  <div className="font-heading text-4xl font-bold leading-none text-wafa-primary lg:text-5xl">
                    {s.n}
                  </div>
                  <p className="mt-4 text-sm leading-relaxed text-wafa-deep/85 lg:text-base">
                    {s.text}
                  </p>
                </div>
              </li>
            ))}
          </ol>
        </div>
      </div>
    </section>
  );
}
